import supabaseClient from '../supabase/supabase';

export const supabase = supabaseClient;

/**
 * Since credentials are auto-injected or hardcoded in the client initialization,
 * we return true to ensure the application uses the Supabase client.
 */
export const isSupabaseConfigured = () => true;